import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { Database } from '../types/database';

let supabaseInstance: SupabaseClient<Database> | null = null;

/**
 * Initialize the Supabase client. Must be called before using getSupabase().
 */
export const initSupabase = (url: string, anonKey: string): SupabaseClient<Database> => {
  if (!supabaseInstance) {
    supabaseInstance = createClient<Database>(url, anonKey, {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
      },
    });
  }
  return supabaseInstance;
};

/**
 * Get the initialized Supabase client.
 * @throws Error if initSupabase() hasn't been called yet.
 */
export const getSupabase = (): SupabaseClient<Database> => {
  if (!supabaseInstance) {
    throw new Error('Supabase client not initialized. Call initSupabase first.');
  }
  return supabaseInstance;
};

// Calculator types matching the backend
export enum CalculatorKind {
  EVENTS = 'EVENTS',
  TRAVEL = 'TRAVEL',
  PERSONAL = 'PERSONAL',
  SPORT = 'SPORT',
}

export enum CalculatorName {
  MONACO_EVENT = 'monaco-event',
  MONACO_TRAVEL = 'monaco-travel',
  NET0_EVENT = 'net0-event',
  NET0_TRAVEL = 'net0-travel',
  NET0_PERSONAL = 'net0-personal',
  NET0_COMMUTE = 'net0-commute',
}

export default { initSupabase, getSupabase };
